module.exports = __webpack_public_path__ + "static/idea-82f50d84ad00652d1988e234cb23b9ce.png";